// MUI imports
import { CircularProgress, Grid } from '@mui/material';
//Third party imports
import { useSelector } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

// routing
import PrivateRoutes from 'routes/PrivateRoutes';
import PublicRoutes from 'routes/PublicRoutes';

// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import { AUTHENTICATED, LOADING } from 'types';
import { SnackbarProvider } from 'notistack';
import BasicErrorAlert from './ui-component/Alerts/BasicErrorAlert';
import BasicSuccessAlert from './ui-component/Alerts/BasicSuccessAlert';
import BasicWarningAlert from './ui-component/Alerts/BasicWarningAlert';
import basicInfoAlert from './ui-component/Alerts/BasicInfoAlert';
import { useAuth } from 'hooks/useAuth';
import { useEffect } from 'react';

// ==============================|| APP ||============================== //

const App = () => {
    const customization = useSelector((state) => state.customization);
    const { status, checkAuthToken } = useAuth();

    useEffect(() => {
        checkAuthToken();
    }, []);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes(customization)}>
                <CssBaseline />
                <SnackbarProvider
                    maxSnack={3}
                    autoHideDuration={'null'}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    Components={{
                        basicErrorAlert: BasicErrorAlert,
                        basicSuccessAlert: BasicSuccessAlert,
                        basicWarningAlert: BasicWarningAlert,
                        basicInfoAlert: basicInfoAlert
                    }}
                >
                    {status === LOADING ? (
                        <Grid container justifyContent="center" alignItems="center" sx={{ height: '100vh' }}>
                            <CircularProgress />
                        </Grid>
                    ) : (
                        <NavigationScroll>{status === AUTHENTICATED ? <PrivateRoutes /> : <PublicRoutes />}</NavigationScroll>
                    )}
                </SnackbarProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
